import { Box } from '@chakra-ui/react'
import { ReactNode, SelectHTMLAttributes } from 'react'
import { ChevronDown } from 'lucide-react'

interface NativeSelectRootProps {
  children: ReactNode
  size?: 'sm' | 'md' | 'lg'
}

interface NativeSelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode
}

export function NativeSelectRoot({ children }: NativeSelectRootProps) {
  return (
    <Box position="relative" display="inline-block" w="full">
      {children}
      <Box
        position="absolute"
        right={3}
        top="50%"
        transform="translateY(-50%)"
        pointerEvents="none"
      >
        <ChevronDown size={20} />
      </Box>
    </Box>
  )
}

export function NativeSelectField({ children, ...props }: NativeSelectFieldProps) {
  return (
    <select
      {...props}
      style={{
        width: '100%',
        padding: '0.625rem',
        paddingRight: '2.5rem',
        borderRadius: '0.375rem',
        border: '1px solid',
        borderColor: 'var(--chakra-colors-gray-300)',
        fontSize: '1rem',
        lineHeight: '1.5',
        backgroundColor: 'var(--chakra-colors-white)',
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        ...props.style,
      }}
    >
      {children}
    </select>
  )
}
